<template>
  <div class="content">
    <div class="header">
      <div class="header-left">
        <div class="header-left-box">
          <!-- <el-image :src="dataForm.logo" class="left-iamge"></el-image> -->
          <div class="left-title">
            <div class="left-title_text">
              <i style="font-weight: 900">DKP评级</i>
            </div>
            <div>坚持服务是我们的唯一产品</div>
          </div>
        </div>
      </div>
      <div class="header-right">
        <div class="sousuo">
          <el-input v-model="sousuo" class="sousuo-inpput"></el-input>
          <div class="iamge" @click="doSousuo">
            <el-image :src="require('../../assets/images/sousuo.png')"></el-image>
          </div>
        </div>
        <div class="logon">
          <el-button v-if="!loginStatus" @click="loginButton">登录 / 注册</el-button>
          <el-dropdown trigger="click">
            <div class="login-user" v-if="loginStatus">
              <div class="login-user-image">
                <el-image :src="parsedUserData.headShot" fit="cover" class="login-user-image_2"></el-image>
              </div>
              <div class="login-user-name">{{ parsedUserData.nickName }}</div>
              <div class="login-user-xiala">
                <el-image :src="require('../../assets/images/xiala.png')" fit="cover"
                  class="login-user-xiala_2"></el-image>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" class="logon_menu">
              <el-dropdown-item>
                <div class="logon_menu-li" @click="doPersonalCenter('1')">
                  <div class="logon_menu-li-img">
                    <el-image :src="require('../../assets/images/songping.png')"></el-image>
                  </div>
                  <div class="logon_menu-li-test">我的送评</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="logon_menu-li" @click="doPersonalCenter('0')">
                  <div class="logon_menu-li-img">
                    <el-image :src="require('../../assets/images/gerenzhongxin.png')"></el-image>
                  </div>
                  <div class="logon_menu-li-test">个人中心</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="logon_menu-li" @click="doPersonalCenter('2')">
                  <div class="logon_menu-li-img">
                    <el-image :src="require('../../assets/images/zhanghuguanli .png')"></el-image>
                  </div>
                  <div class="logon_menu-li-test">账户管理</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item class="logon_menu_item">
                <div class="logon_menu-li logon_menu-li-test" @click="doLogout">
                  退出登录
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="nav-box">
        <div class="nav-box_li" :class="navIndex == 'home' ? 'active' : ''" @click="doNav('home')">
          首页
        </div>
        <div class="nav-box_li" :class="navIndex == 'submitComments' ? 'active' : ''" @click="doNav('submitComments')">
          我要送评
        </div>
        <div class="nav-box_li" :class="navIndex == 'chargingStandards' ? 'active' : ''"
          @click="doNav('chargingStandards')">
          收费标准
        </div>
        <el-dropdown class="nav_dropdown">
          <div class="nav-box_li" :class="navIndex == 'ratingCriteria' ? 'active' : ''"
            @click="doNav('ratingCriteria', 0)">
            评级标准
          </div>
          <el-dropdown-menu slot="dropdown" class="nav_menu">
            <el-dropdown-item class="nav_menu-ul" v-for="(item, index) in  btnList" :key="index">
              <div class="nav_menu-li" @click="doNav('ratingCriteria', index)">
                {{ item.ratingType }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav-box_li" :class="navIndex == 'customTag' ? 'active' : ''" @click="doNav('customTag')">
          个性标签
        </div>
        <el-dropdown class="nav_dropdown">
          <div class="nav-box_li" :class="navIndex == 'premiumCisplay' ? 'active' : ''"
            @click="doNav('premiumCisplay', dataList[0].id)">
            臻品展示
          </div>
          <el-dropdown-menu slot="dropdown" class="nav_menu">
            <el-dropdown-item class="nav_menu-ul" v-for="(item, index) in dataList" :key="index">
              <div class="nav_menu-li" @click="doNav('premiumCisplay', item.id)">
                {{ item.optionName }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="nav_dropdown">
          <div class="nav-box_li" :class="navIndex == 'companyOverview' ? 'active' : ''"
            @click="doNav('companyOverview')">
            公司概括
          </div>
          <el-dropdown-menu slot="dropdown" class="nav_menu">
            <el-dropdown-item class="nav_menu-ul">
              <div class="nav_menu-li" @click="doNav('companyOverview')">
                公司简介
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="nav_menu-ul">
              <div class="nav_menu-li" @click="doNav('contactUs')">
                联系我们
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav-box_li" @click="doTuoguan()">托管云仓</div>
      </div>
    </div>
    <!-- <el-carousel :interval="3000" arrow="always">
            <el-carousel-item v-for="item in 4" :key="item">
                <h3>{{ item }}</h3>
            </el-carousel-item>
        </el-carousel> -->
  </div>
</template>
<script>
import { collectionGetUsedAll } from "../../api/selectionOfCollections";

import { getByFirm } from "../../api/companyProfile";
import { getUserData, setAboutUs } from "../../utils/anth";
import { webGetAllRatingCriteria } from "../../api/ratingCriteria";
export default {
  inject: ["reload"],
  data() {
    return {
      sousuo: null,
      loginStatus: false, //是否登录
      dataList: [],
      navIndex: "home",
      dataForm: {},
      parsedUserData: {},
      btnList: [
      ],
    };
  },
  watch: {
    "$store.state.navIndex"(newVal, oldVal) {
      this.navIndex = newVal;
    },
  },
  // props: {
  //     navIndex: {
  //         type: String,
  //         default: "home",
  //     },
  // },
  created() {
    const userData = getUserData("userData");
    if (userData !== undefined) {
      this.parsedUserData = JSON.parse(userData);
      if (this.parsedUserData !== "") {
        this.loginStatus = true;
      }
    }
    this.getByFirm();
    // console.log(this.$route);
    let path = this.$route.path;
    this.navIndex = path != "/" ? path.slice(1, path.length) : "home";
    // console.log(path, "path");
    // console.log(this.navIndex, "this.navIndex");
    this.collectionGetUsedAll();
    this.webGetAllRatingCriteria()
  },
  mounted() { },
  methods: {
    //评级标准数据
    async webGetAllRatingCriteria() {
      const res = await webGetAllRatingCriteria({});
      if (res.code === "success") {
        this.btnList = res.data.list;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询甄选藏品的目录
    collectionGetUsedAll() {
      collectionGetUsedAll({ page: null, limit: null }).then((res) => {
        if (res.code === "success") {
          this.dataList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关于我们
    getByFirm() {
      getByFirm().then((res) => {
        if (res.code == "success") {
          let data = res.data;
          this.dataForm = res.data;
          this.$store.dispatch("dispatchImage", data.logo);
          setAboutUs(JSON.stringify(data));
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 搜索
    doSousuo() {
      // console.log(this.sousuo);
      this.$router.push({
        path: "/notice",
        query: {
          name: this.sousuo,
        },
      });
      this.navIndex = null;
    },
    // tab页切换
    doNav(index, id) {
      let path = this.$route.path;
      console.log(index, id, 'index,id');
      if (index == "home" && path !== "/") {
        this.$router.push({ path: "/" });
        this.navIndex = index;
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (
        index == "chargingStandards" &&
        path !== "/chargingStandards"
      ) {
        this.$router.push({ path: "/chargingStandards" });
        this.navIndex = index;
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (index == "ratingCriteria") {
        this.$router.push({ path: "/ratingCriteria", query: { index: id } });
        this.navIndex = index;
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (index == "submitComments" && path !== "/submitComments") {
        this.$router.push({ path: "/submitComments" });
        this.navIndex = index;
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (index == "premiumCisplay") {
        this.$router.push({
          path: "/premiumCisplay",
          query: {
            id: id,
          },
        });
        this.navIndex = index;
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (index == "companyOverview" && path !== "/companyOverview") {
        this.$router.push({ path: "/companyOverview" });
        this.navIndex = index;
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (index == "contactUs" && path !== "/contactUs") {
        this.$router.push({ path: "/contactUs" });
        this.navIndex = "companyOverview";
        this.$store.dispatch("dispatchNavIndex", index);
      } else if (index == "customTag" && path !== "/customTag") {
        this.$router.push({ path: "/customTag" });
        this.navIndex = "companyOverview";
        this.$store.dispatch("dispatchNavIndex", index);
      }
    },
    // 个人中心
    doPersonalCenter(id) {
      this.$router.push({
        path: "/personalCenter",
        query: {
          id: id,
        },
      });
      this.navIndex = null;
    },
    // 托管云仓
    doTuoguan() {
      window.open("http://www.youshoucang.com/index.html", "_blank");
    },
    doLogout() {
      this.$router.push({ path: "/login" });
      // 退出登录
      sessionStorage.removeItem("userData");
    },
    //登录/注册
    loginButton() {
      this.$router.push({ path: "/login" });
      sessionStorage.removeItem("userData");
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background-color: #ffffff;

  .header {
    width: 100%;
    height: 96px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    .header-left {
      width: auto;
      height: 100%;
      padding-right: 16.25%;

      .header-left-box {
        width: auto;
        height: 100%;
        display: flex;
        align-items: center;

        .left-iamge {
          width: 72px;
          height: 72px;
        }

        .left-title {
          width: auto;
          height: auto;
          font-size: 20px;
          font-weight: 300;
          line-height: 20px;
          color: #333333;
          padding-left: 10px;

          .left-title_text {
            font-size: 32px;
            font-weight: 600;
            line-height: 32px;
            padding-bottom: 4px;
          }
        }
      }
    }

    .header-right {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;

      .sousuo {
        width: 320px;
        height: auto;
        border-radius: 25px;
        // background-color: #EEEEEE;
        margin-right: 7px;
        position: relative;

        /deep/ .sousuo-inpput {
          width: 100%;
          border-radius: 25px;
          font-size: 18px;

          .el-input__inner {
            height: 50px;
            border-radius: 25px;
            padding-left: 55px;
            background-color: #eeeeee;
          }
        }

        .iamge {
          width: 28px;
          height: 28px;
          cursor: pointer;
          position: absolute;
          top: 12px;
          left: 10px;
          z-index: 99;

          image {
            width: 100%;
            height: 100%;
          }
        }
      }

      .logon {
        width: auto;
        height: auto;

        /deep/ .el-button {
          width: 150px;
          height: 50px;
          border-radius: 25px;
          background: linear-gradient(10deg, #ef7c4c, #f3e145);
          color: #ffffff;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .login-user {
          width: auto;
          height: auto;
          display: flex;
          align-items: center;
          cursor: pointer;

          .login-user-image {
            width: 50px;
            height: 50px;
            min-width: 50px;

            .el-image {
              width: 100%;
              height: 100%;
            }
          }

          .login-user-name {
            width: 100%;
            font-size: 20px;
            color: #333333;
            font-weight: 400;
            padding-left: 0.9%;
            padding-right: 0.42%;
          }

          .login-user-xiala {
            width: 20px;
            height: 7px;
            padding-top: 3px;
          }
        }

        // /deep/ .el-dropdown-menu {
        //     width: 222px !important;
        // }
      }
    }
  }

  @media screen and (max-width: 1680px) {
    .header {
      height: 84px;

      .left-iamge {
        width: 64px !important;
        height: 64px !important;
      }

      .left-title {
        font-size: 19px !important;
        line-height: 19px !important;
        padding-left: 9px !important;

        .left-title_text {
          font-size: 28px !important;
          line-height: 28px !important;
          padding-bottom: 4px !important;
        }
      }

      .sousuo {
        width: 266px !important;

        /deep/ .sousuo-inpput {
          border-radius: 21px !important;
          font-size: 16px !important;

          .el-input__inner {
            height: 42px !important;
            border-radius: 21px !important;
            padding-left: 50px !important;
          }
        }

        .iamge {
          width: 25px !important;
          height: 25px !important;
          position: absolute;
          top: 8px !important;
          left: 8px !important;
        }
      }

      .logon {
        /deep/ .el-button {
          width: 132px !important;
          height: 42px !important;
          border-radius: 21px !important;
          font-size: 16px !important;
        }

        .login-user {
          .login-user-image {
            width: 42px !important;
            height: 42px !important;
            min-width: 42px !important;
          }

          .login-user-name {
            font-size: 18px !important;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .header {
      height: 68px;

      .left-iamge {
        width: 52px !important;
        height: 52px !important;
      }

      .left-title {
        font-size: 16px !important;
        line-height: 16px !important;
        padding-left: 8px !important;

        .left-title_text {
          font-size: 23px !important;
          line-height: 23px !important;
          padding-bottom: 4px !important;
        }
      }

      .sousuo {
        width: 228px !important;

        /deep/ .sousuo-inpput {
          border-radius: 18px !important;
          font-size: 14px !important;

          .el-input__inner {
            height: 36px !important;
            border-radius: 18px !important;
            padding-left: 45px !important;
          }
        }

        .iamge {
          width: 20px !important;
          height: 20px !important;
          position: absolute;
          top: 6px !important;
          left: 8px !important;
        }
      }

      .logon {
        /deep/ .el-button {
          width: 112px !important;
          height: 36px !important;
          border-radius: 18px !important;
          font-size: 14px !important;
        }

        .login-user {
          .login-user-image {
            width: 36px !important;
            height: 36px !important;
            min-width: 36px !important;
          }

          .login-user-name {
            font-size: 16px !important;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .header {
      height: 64px;

      .left-iamge {
        width: 49px !important;
        height: 49px !important;
      }

      .left-title {
        font-size: 15px !important;
        line-height: 15px !important;
        padding-left: 7px !important;

        .left-title_text {
          font-size: 21px !important;
          line-height: 21px !important;
          padding-bottom: 4px !important;
        }
      }

      .sousuo {
        width: 213px !important;

        /deep/ .sousuo-inpput {
          border-radius: 17px !important;
          font-size: 15px !important;

          .el-input__inner {
            height: 33px !important;
            border-radius: 17px !important;
            padding-left: 40px !important;
          }
        }

        .iamge {
          width: 24px !important;
          height: 24px !important;
          position: absolute;
          top: 4.5px !important;
          left: 8px !important;
        }
      }

      .logon {
        /deep/ .el-button {
          width: 105px !important;
          height: 33px !important;
          border-radius: 17px !important;
          font-size: 15px !important;
        }

        .login-user {
          .login-user-image {
            width: 33px !important;
            height: 34px !important;
            min-width: 33px !important;
          }

          .login-user-name {
            font-size: 15px !important;
          }
        }
      }
    }
  }

  .nav {
    width: 100%;
    height: 50px;
    margin-top: 96px;
    background-color: #ef7c4c;

    .nav-box {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .nav-box_li {
        width: auto;
        height: 100%;
        font-size: 20px;
        color: #ffd8c8;
        padding: 0 40px;
        display: flex;
        align-items: center;
        cursor: pointer;
        font-family: PingFang-SC-Medium;
      }

      .nav-box_li:hover {
        background-color: #ec662e;
        color: #ffffff;
      }

      .active {
        background-color: #ec662e;
        color: #ffffff;
      }
    }
  }

  @media screen and (max-width: 1680px) {
    .nav {
      height: 40px;
      margin-top: 84px;

      .nav-box {
        .nav-box_li {
          font-size: 18px;
        }
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .nav {
      height: 35px;
      margin-top: 68px;

      .nav-box {
        .nav-box_li {
          font-size: 16px;
        }
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .nav {
      height: 30px;
      margin-top: 64px;

      .nav-box {
        .nav-box_li {
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue